namespace InvData.Models {

    export interface TagClassData {
        id?: number;
        code?: string;
        label?: string;
        parentTagId?: number;
        tagSet: TagSet;
        level?: number;
        tagOrder?: number;

        childTags?: Tag[];
    }

    export class Tag {

        public id: number;
        public code: string;
        public label: string;
        public childTags: Tag[];
        public level: number;
        public parentTagId: number;
        public tagSet: TagSet;

        /**
         * tagOrder is the order the tag appears in within the parent tag.
         */
        public tagOrder: number;


        constructor(tagData: TagClassData) {
            this.id = tagData.id ? tagData.id : null;
            this.code = tagData.code ? tagData.code : null;
            this.label = tagData.label ? tagData.label : null;
            this.childTags = tagData.childTags ? tagData.childTags : null;
            this.level = tagData.level;
            this.tagOrder = tagData.tagOrder;

            this.parentTagId = tagData.parentTagId ? tagData.parentTagId : null;
            this.tagSet = tagData.tagSet;
        }

        public getParentTag(): Tag {
            if (this.parentTagId) {
                return this.tagSet.tryGetTagById(this.parentTagId);
            }
            else {
                return null;
            }
        }

        public getLevel(levelIndex: number): Tag {
            if (levelIndex == this.level) {
                return this;
            }
            else {
                var parentTag = this.getParentTag();
                if (parentTag) {
                    return parentTag.getLevel(levelIndex);
                }
            }

            return null;
        }

        public getLowestLevel(levelIndex: number): Tag {
            if (levelIndex >= this.level) {
                return this;
            }
            else {
                var parentTag = this.getParentTag();
                if (parentTag) {
                    return parentTag.getLevel(levelIndex);
                }
            }

            return null;
        }

        public getLevelLabel(levelIndex: number): string {
            var levelTag = this.getLevel(levelIndex);
            if (levelTag) {
                return levelTag.label;
            }

            return null;
        }

        /**
         * Returns true if this tag is branchTag or a child tag of the branchTag.
         * @param branchTag
         */
        public isInBranch(branchTag: Tag): boolean {
            if (this.id == branchTag.id) {
                return true;
            }
            else if (this.parentTagId) {
                var parentTag = this.getParentTag();
                if (parentTag) {
                    return parentTag.isInBranch(branchTag);
                }
            }

            return false;
        }
    }

}
